import { gql } from '@lcs/shared/api';

export const getDevicesQuery = gql`
   query GetDevices($first: Int!, $filters: String, $after: String, $orderingOptions: [OrderingOption!]) {
      devicesConnection(first: $first, filters: $filters, after: $after, orderingOptions: $orderingOptions) {
         totalCount
         pageInfo {
            hasNextPage
            endCursor
            hasPreviousPage
            startCursor
         }
         items {
            deviceId
            deviceTypeId
            macAddress
            deviceType {
               name
            }
            account {
               accountId
               name
            }
            serialNumber
            lastFirmwareReported
            lastProvisionedDate
            ztStatus
            notes
            createDate
            phone {
               extension {
                  extensionId
                  name
                  number
               }
               extensionPhone {
                  defaultPhoneNumber {
                     phoneNumber
                  }
               }
               sipUsersConnection {
                  items {
                     sipUserId
                     userName
                     isConnected
                     lastConnected
                     isHacked
                     isFraud
                     internalIps
                     externalIps
                     phone {
                        extension {
                           extensionId
                           number
                           name
                        }
                        phoneId
                        phoneType
                        adminPassword
                        devicesConnection {
                           items {
                              deviceId
                              deviceTypeId
                              macAddress
                           }
                        }
                     }
                  }
               }
            }
            baseStationHandsetsConnection {
               items {
                  phone {
                     sipUsersConnection {
                        items {
                           isConnected
                           lastConnected
                           externalIps
                           internalIps
                        }
                     }
                     adminPassword
                  }
               }
            }
            createUser {
               name
            }
            updateDate
            updateUser {
               name
            }
         }
      }
   }
`;
